import React from 'react';
import { Countdown } from './Countdown';
import { TrustBadges } from './TrustBadges';
import { FadeIn } from './FadeIn';
import { ChevronRightIcon } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-[100svh] flex flex-col justify-center items-center px-4 py-5 overflow-hidden" data-id="element-79">
      {/* Background grid */}
      <div className="absolute inset-0 opacity-5 pointer-events-none" style={{
      backgroundImage: 'linear-gradient(rgba(245,200,66,0.3) 1px, transparent 1px), linear-gradient(90deg, rgba(245,200,66,0.3) 1px, transparent 1px)',
      backgroundSize: '60px 60px'
    }} data-id="element-80" />
      {/* Gold glow top */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[300px] bg-pump-gold/10 rounded-full blur-[120px] pointer-events-none" data-id="element-81" />

      <div className="max-w-3xl mx-auto text-center relative z-10 flex flex-col items-center" data-id="element-82">
        <FadeIn data-id="element-83">
          <span className="inline-block bg-pump-surface border border-pump-muted text-gray-300 text-[10px] sm:text-xs font-bold tracking-widest uppercase px-3 py-1 rounded-full mb-3" data-id="element-84">
            El Viral PDF Lab™ — Formación para Instructores
          </span>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-85">
          <h1 className="text-3xl sm:text-5xl md:text-6xl font-black mb-3 leading-[0.95] tracking-tight uppercase text-balance text-pump-gold drop-shadow-[0_0_30px_rgba(245,200,66,0.4)]" data-id="element-86">
            Resolvé todo tu año con este pack
          </h1>
        </FadeIn>

        <FadeIn delay={0.15} data-id="element-87">
          <p className="text-base sm:text-xl text-white font-bold mb-4 max-w-2xl mx-auto leading-snug" data-id="element-88">
            La guía definitiva para dominar el escenario, llenar tus clases y
            volverte el instructor que nadie quiere perderse.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-89">
          <img src="https://cdn.magicpatterns.com/uploads/tZB8Xk4B7U4YJtGscaavSB/imagen_mock_up.png" alt="El Protocolo del Instructor Inolvidable — 6 tomos y 5 bonos del megapack" className="w-full max-w-2xl mx-auto mb-4 rounded-xl drop-shadow-[0_10px_40px_rgba(245,200,66,0.15)]" data-id="element-90" />
        </FadeIn>

        <FadeIn delay={0.25} className="flex flex-col items-center gap-3 w-full" data-id="element-91">
          <div className="flex flex-col items-center" data-id="element-92">
            <span className="text-gray-400 text-xs sm:text-sm font-medium" data-id="element-93">
              Precio de lanzamiento
            </span>
            <span className="text-4xl sm:text-5xl font-display font-black text-pump-gold leading-none drop-shadow-[0_0_20px_rgba(245,200,66,0.4)]" data-id="element-94">
              $19.999
            </span>
          </div>

          <Countdown data-id="element-95" />

          <button onClick={scrollToPricing} className="w-full sm:w-auto bg-pump-gold hover:bg-pump-goldHover text-pump-dark font-display rounded-xl px-8 sm:px-10 py-3 sm:py-4 flex flex-col items-center justify-center transition-all transform hover:scale-[1.02] active:scale-[0.98] shadow-[0_0_40px_rgba(245,200,66,0.3)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-pump-gold" data-id="element-96">
            <span className="flex items-center gap-2 font-black text-lg sm:text-2xl leading-none text-pump-dark" data-id="element-97">
              QUIERO LA OFERTA
              <ChevronRightIcon className="w-5 h-5 sm:w-7 sm:h-7" strokeWidth={3} data-id="element-98" />
            </span>
            <span className="font-bold text-sm sm:text-base text-pump-dark/70 mt-1" data-id="element-99">
              $19.999 — Ver oferta completa
            </span>
          </button>

          <TrustBadges data-id="element-100" />
        </FadeIn>
      </div>
    </section>;
}